import React from 'react'
import classNames from 'classnames'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { withModal } from '../../../modules/modal/withModal'
import NotificationControllerModal from './NotificationControllerModal'
import { withAlertModal } from '../../../modules/modal/withAlertModal'
import IconButton from '../../views/buttons/IconButton'
import { bell } from 'react-icons-kit/fa'
import { Icon } from 'react-icons-kit/Icon'

class NotificationButton extends React.Component {
  state = {}

  componentDidMount() {}

  render() {
    return (
      <NotificationViewButton
        onShowModal={
          this.props.haveQuota
            ? this.props.showNotificationModal
            : this.props.showConfirmModal
        }
        haveQuota={this.props.haveQuota}
      >
        Notification
      </NotificationViewButton>
    )
  }
}

const NotificationViewButton = ({ children, haveQuota, onShowModal }) => (
  <a className="navbar-item" onClick={onShowModal}>
    <span className="icon">
      <Icon icon={bell} />
    </span>
    <span>{children}</span>
  </a>
)

export default compose(
  connect(({ portal: { notificationQuota } }) => ({
    notificationQuota,
    haveQuota: notificationQuota > 0,
  })),
  withAlertModal({
    props: ownProps => ({
      showModalAttr: 'showConfirmModal',
      title: 'ข้อความ',
      content: 'จำนวนโควต้าในการส่งข้อความได้หมดแล้ว',
    }),
  }),
  withModal(NotificationControllerModal, {
    props: () => ({
      showModalAttr: 'showNotificationModal',
    }),
  }),
)(NotificationButton)



// WEBPACK FOOTER //
// ./src/components/templates/notification-controller/NotificatioButton.js